import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26b0472e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  align: "center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "重 置 密 码", -1));
import { ElMessage } from "element-plus";
import { reactive, ref } from "vue";
import { sendnewpassword } from "../request/userlist";
export default /*#__PURE__*/_defineComponent({
  __name: 'setpassword',
  emits: ["clickChild"],
  setup(__props, {
    emit: __emit
  }) {
    const emailForm = reactive({
      name: ""
    });
    const emailFormRef = ref();
    const submitemail = formEl => {
      let emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
      if (emailReg.test(emailForm.name)) {
        console.log("res");
        sendnewpassword(emailForm.name).then(res => {
          console.log(res);
          if (res.data.code == 200) {
            ElMessage(res.data.msg);
            clickChild(1);
          } else {
            ElMessage(res.data.msg);
          }
        });
      } else {
        ElMessage("邮箱格式错误");
        return;
      }
    };
    const emit = __emit;
    const clickChild = type => {
      let param = {
        typeid: type
      };
      //传递给父组件
      emit("clickChild", param);
    };
    const exit = () => {
      clickChild(0);
    };
    return (_ctx, _cache) => {
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_divider), _createVNode(_component_el_form, {
        ref_key: "emailFormRef",
        ref: emailFormRef,
        model: emailForm,
        "status-icon": "",
        "label-width": "80px",
        class: "demo-ruleForm"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "邮箱:",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: emailForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => emailForm.name = $event),
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => submitemail(emailFormRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "register_btn",
            onClick: _cache[2] || (_cache[2] = $event => exit())
          }, {
            default: _withCtx(() => [_createTextVNode("退出")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});